import * as zod from 'zod';

export default zod.object({
  miraiControllerId: zod.string(),
  skillId: zod.number(),
});
